import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss']
})
export class DatepickerComponent {
    @Input() label : string = 'Zvolte datum';
}



// WEBPACK FOOTER //
// /app/src/SharedModule/DatepickerComponent/datepicker.component.ts